import { isValidPostalCode, PostcodeInput, SearchView } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent, useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'

import { usePrincipal } from '../../../../application/authentication'
import { ApiClient } from '../../../../clients/api'
import { Address } from '../../../../domain'
import { useApiErrorHandlingAsync } from '../../../../hooks/auth'
import { TKeyBuilder } from '../../../internationalisation'

export interface Props {
  onSelect: (address: Address) => void
  tKey: TKeyBuilder
  tName: string
  t: TFunction
}

const dataLookup = (client: ApiClient, postalCode: string) =>
  isValidPostalCode(postalCode)
    ? client.lookupAddress(postalCode)
    : Promise.resolve(undefined)

const renderListItemContent = ({ label }: Address) => <span>{label}</span>

export const AddressSearchView: FunctionComponent<Props> = ({
  onSelect,
  tName,
  tKey,
  t,
}) => {
  const { apiClient } = usePrincipal()

  const [searchTerm, setSearchTerm] = useState('')
  const asyncDataEntries = useApiErrorHandlingAsync(dataLookup, [apiClient, searchTerm], {
    setLoading: (state) => ({ ...state, loading: true }),
  })
  const debouncedOnChange = useDebouncedCallback(setSearchTerm, 250)

  return (
    <SearchView
      identifier={tName}
      placeholder={t(tKey(tName, 'placeholder'))}
      notFoundMessage={t(tKey(tName, 'validation.notFound'))}
      onSelect={onSelect}
      onInputChange={debouncedOnChange}
      loading={asyncDataEntries.loading}
      results={asyncDataEntries.result}
      Input={PostcodeInput}
      renderListItemContent={renderListItemContent}
    />
  )
}
